"use strict";

exports.__esModule = true;
var _TriggerSubscription = require("./TriggerSubscription");
Object.keys(_TriggerSubscription).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TriggerSubscription[key]) return;
  exports[key] = _TriggerSubscription[key];
});